import { Size } from '@/hooks/useScreenSize';

// Style maps for sizes
const dialogContainerClassMap: Record<Size, string> = {
  sm: 'duration-800 relative w-full border-color-Gradients-Border-Card-Outline border-[2px] rounded-tl-2xl rounded-tr-2xl border-none shadow-cartBottomDialogShadow transition-all ease-in-out',
  md: 'duration-800 relative w-full border-color-Gradients-Border-Card-Outline border-[2px] rounded-tl-2xl rounded-tr-2xl border-none pt-spacing-none shadow-cartBottomDialogShadow transition-all ease-in-out',
  lg: 'relative w-full rounded-t-border-radius-xl border-t-[2px] border-[#1cadff] bg-color-background-bottomsheet-priceSummary-desktop shadow-custom-one transition-all ease-in-out',
  xl: 'relative w-full rounded-t-border-radius-xl border-t-[2px] border-[#1cadff] bg-color-background-bottomsheet-priceSummary-desktop shadow-custom-one transition-all ease-in-out',
  xxl: 'relative w-full rounded-t-border-radius-xl border-t-[2px] border-[#1cadff] bg-color-background-bottomsheet-priceSummary-desktop shadow-custom-one transition-all ease-in-out',
};

const moreInfodialogContainerClassMap: Record<Size, string> = {
  sm: 'duration-800 relative w-full rounded-tl-2xl rounded-tr-2xl border-none bg-Gradients-Background-bottomsheet-bg-bottomsheet-bg shadow-cartBottomDialogShadow transition-all ease-in-out',
  md: 'duration-800 relative w-full rounded-tl-2xl rounded-tr-2xl border-none bg-Gradients-Background-bottomsheet-bg-bottomsheet-bg shadow-cartBottomDialogShadow transition-all ease-in-out',
  lg: 'relative w-full rounded-tl-xl rounded-tr-xl bg-gradient-bundle-card shadow-custom-one transition-all ease-in-out',
  xl: 'relative w-full rounded-tl-2xl rounded-tr-2xl bg-gradient-bundle-card shadow-custom-one transition-all ease-in-out',
  xxl: 'relative w-full rounded-tl-2xl rounded-tr-2xl bg-gradient-bundle-card shadow-custom-one transition-all ease-in-out',
};

const dialogContentClassMap: Record<Size, string> = {
  sm: 'border-none',
  md: 'border-none',
  lg: 'border-none',
  xl: 'border-none',
  xxl: 'border-none',
};

const stickyContainerClassMap: Record<Size, string> = {
  sm: 'sticky inset-0 left-0 right-0 z-[999] m-auto',
  md: 'sticky inset-0 left-0 right-0 z-[999] m-auto',
  lg: 'sticky inset-0 left-0 right-0 z-[999] m-auto',
  xl: 'sticky inset-0 left-0 right-0 z-[999] m-auto',
  xxl: 'sticky inset-0 left-0 right-0 z-[999] m-auto',
};

const transparentLayerClassMap: Record<Size, string> = {
  sm: 'fixed inset-0 z-40 bg-color-background-overlay-mobile bg-opacity-80 z-[999]',
  md: 'fixed inset-0 z-40 bg-color-background-overlay-mobile bg-opacity-80 z-[999]',
  lg: 'fixed inset-0 z-40 bg-color-background-overlay-mobile bg-opacity-80 z-[999]',
  xl: 'fixed inset-0 z-40 bg-color-background-overlay-mobile bg-opacity-80 z-[999]',
  xxl: 'fixed inset-0 z-40 bg-color-background-overlay-mobile bg-opacity-80 z-[999]',
};

const dialogCloseClassMap: Record<Size, string> = {
  sm: 'absolute left-1/2 top-0 z-[9999] flex -translate-x-1/2 -translate-y-[calc(100%+12px)] items-center justify-center',
  md: 'absolute left-1/2 top-0 z-[9999] flex -translate-x-1/2 -translate-y-[calc(100%+12px)] items-center justify-center',
  lg: 'absolute right-4 top-4 z-[9999] flex items-center justify-center',
  xl: 'absolute right-4 top-4 z-[9999] flex items-center justify-center',
  xxl: 'absolute right-4 top-4 z-[9999] flex items-center justify-center',
};

const iconClassMap: Record<Size, string> = {
  sm: '!w-[27px] !h-[27px] ',
  md: '!w-[35.1px] !h-[35.1px]',
  lg: '!w-[27px] !h-[27px]',
  xl: '!w-[27px] !h-[27px]',
  xxl: '!w-[27px] !h-[27px]',
};

const scrollContainerClassMap: Record<Size, string> = {
  sm: 'w-[326px] h-[82px] p-spacing-spacing-16',
  md: 'w-[734px] h-[82px] ',
  lg: 'w-[750px] h-[99x] gap-[10.4px]',
  xl: 'w-[750px] h-[107.4px] ',
  xxl: 'w-[975px] h-[138.9px] ',
};

export {
  dialogContainerClassMap,
  dialogContentClassMap,
  transparentLayerClassMap,
  dialogCloseClassMap,
  iconClassMap,
  stickyContainerClassMap,
  moreInfodialogContainerClassMap,
  scrollContainerClassMap,
};
